// extracted by mini-css-extract-plugin
export default {"payment-page":"styles_payment-page__Pux7s"};